import {useEffect, useState} from "react";
import {Box, Button, FormControl, Grid, InputLabel, Select, TextField} from "@material-ui/core";
import * as React from "react";
import Dialog from "@material-ui/core/Dialog";
import {withStyles} from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import {convertCurrencyFormat, convertToBirthDate} from "../../utils/numberConvertor";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {TransactionsService} from "../Transactions/TransactionsService";
import moment from "jalali-moment";
import {TagService} from "../tagManager/TagService";
import {css} from "@emotion/css";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import {
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoMoneyInputOutlined
} from "@moeindal/base-raiko-panel-components";
import {CategoryParser} from "../../component/raikoCategory/CategoryParser";
import {CategoryService} from "../../component/raikoCategory/CategoryService";

const AddNewTransaction = ({openModal, handleClose, selectedItemId, setNeedRefresh, tagsList}) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new TransactionsService(fundID, token, snackbar, loading)

    const [title, setTitle] = useState("");
    const [amount, setAmount] = useState("");
    const [date, setDate] = useState("");
    const [description, setDescription] = useState("");
    const [transactionKind, setTransactionKind] = useState("COSTS");
    const [enabled, setEnabled] = useState(true);

    const [selectedTagId, setSelectedTagId] = useState(-1);

    const categoryService = new CategoryService(fundID, token)
    const [categoryInlineItems, setCategoryInlineItems] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState(-1)

    console.log("selc ", selectedCategoryId)

    useEffect(() => {
        if (selectedItemId >= 0) {
            getTransactionInfo()
        }
    }, [selectedItemId])

    useEffect(() => {
        if (!openModal) {
            clearFields()
        }

        if (categoryService) {
            categoryService.getCategoryList()
                .then(response => {
                    setCategoryInlineItems(new CategoryParser(response).getCategoryListInlineParser())
                }).catch(reason => {
                ServerErrorHandler(reason, "خطا در دریافت اطلاعات دسته بندی ها", snackbar, loading)
            }).finally(_ => {

            })
        }

    }, [openModal])

    function getTransactionInfo() {
        loading(setLoadingStateDispatch(true))
        service.getTransactionDetail(
            fundID,
            selectedItemId
        ).then(response => {
            setTransactionData(response)

            if (response.categories && response.categories.length > 0)
                setSelectedCategoryId(response.categories[0].id)

            loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(reason, "خطا در دریافت اطلاعات تراکنش !", snackbar, loading)
        })
    }

    // dialog-start
    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });

    const DialogTitle = withStyles(styles)((props) => {
        const {children, classes, onClose, ...other} = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });

    const DialogContent = withStyles((theme) => ({
        root: {
            padding: theme.spacing(2),
        },
    }))(MuiDialogContent);

    const DialogActions = withStyles((theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(1),
        },
    }))(MuiDialogActions);

    // dialog-end

    function checkFieldsCondition() {
        let status = true;
        let message = ""

        if (title.length === 0) {
            status = false
            message = "لطفا عنوان تراکنش را مشخص نمایید!"
        } else if (amount === "0" || amount.length === 0) {
            status = false
            message = "لطفا مبلغ تراکنش را مشخص نمایید!"
        } else if (date.length !== 10) {
            status = false
            message = "لطفا تاریخ تراکنش را به درستی مشخص نمایید!"
        }


        snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, message))
        return status;
    }

    function doChange() {
        if (checkFieldsCondition()) {
            setNeedRefresh(true)

            if (selectedItemId === -1) {
                service.addNewTransaction(
                    service.prepareTransactionData(
                        amount,
                        title,
                        date,
                        transactionKind,
                        enabled,
                        description,
                        selectedTagId,
                        selectedCategoryId
                    ),
                    clearFields
                )
            } else {
                service.updateTransaction(
                    selectedItemId,
                    service.prepareTransactionData(
                        amount,
                        title,
                        date,
                        transactionKind,
                        enabled,
                        description,
                        selectedTagId,
                        selectedCategoryId
                    ))
            }
        }
    }

    function setTransactionData(data) {
        setTitle(data.title)
        setTransactionKind(data.kind)
        setAmount(data.amount)
        setDate(data.payAt ? moment(data.payAt, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD') : "")
        setEnabled(data.enabled)
        setDescription(data.description)
        setSelectedTagId(data.tag ? data.tag.id : -1)
    }

    function clearFields() {
        setTitle("")
        setTransactionKind("COSTS")
        setAmount("")
        setDate("")
        setEnabled(true)
        setDescription("")
        setSelectedTagId(-1)
        setSelectedCategoryId(-1)
    }

    const [confirmDeleteDialogState, setConfirmDeleteDialogState] = useState(false);

    function handleOpenDeleteDialog() {
        setConfirmDeleteDialogState(true)
    }

    function handleCloseDeleteDialog() {
        setConfirmDeleteDialogState(false)
    }

    function doDelete() {
        setNeedRefresh(true)
        loading(setLoadingStateDispatch(true))
        service.deleteTransaction(selectedItemId)
            .then(response => {
                console.log("response is ", JSON.stringify(response))
                handleCloseDeleteDialog()
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "تراکنش با موفقیت حذف شد."))
                loading(setLoadingStateDispatch(false))
                handleClose()
            }).catch(reason => {
            ServerErrorHandler(reason, "خطا در حذف تراکنش", snackbar, loading)
        })
    }

    return (

        <>
            <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={openModal}
                    id="PersonalizedMediumDialog">
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    {selectedItemId >= 0 ? "ویرایش تراکنش" : "افزودن تراکنش جدید"}
                </DialogTitle>
                <section style={{padding: "1rem", flexGrow: "1"}}>
                    <Box className="d-flex flex-grow-1 w-100" sm={12}>
                        <Grid className='d-flex flex-row flex-wrap flex-grow-1 w-100' sm={12}
                              style={{marginTop: '1rem'}}>
                            <Grid sm={6} md={6} lg={6} xl={3} className="w-100 p-2">
                                <TextField
                                    className="w-100"
                                    id="outlined-basic"
                                    label="عنوان"
                                    variant="outlined"
                                    value={title}
                                    onChange={e => {
                                        setTitle(e.target.value)
                                    }}/>
                            </Grid>
                            <Grid sm={6} md={6} lg={6} xl={3} className="w-100 p-2">
                                <FormControl variant="outlined" className="w-100">
                                    <InputLabel htmlFor="filled-age-native-simple">نوع تراکنش</InputLabel>
                                    <Select label="نوع تراکنش"
                                            value={transactionKind}
                                            onChange={e => {
                                                setTransactionKind(e.target.value)
                                            }}>
                                        <option className="bg_active_state p-2" value={"REVENUES"}>درآمد</option>
                                        <option className="bg_deActive_state p-2" value={"COSTS"}>هزینه</option>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid sm={6} md={6} lg={6} xl={3} className="w-100 p-2">
                                <RaikoMoneyInputOutlined
                                    labelText={"مبلغ (ریال)"}
                                    value={amount}
                                    setValue={setAmount}
                                />
                            </Grid>
                            <Grid sm={6} md={6} lg={6} xl={3} className="w-100 p-2">
                                <TextField
                                    className="w-100"
                                    id="outlined-basic"
                                    label="تاریخ"
                                    variant="outlined"
                                    value={convertToBirthDate(date)}
                                    onChange={event => setDate(convertToBirthDate(event.target.value))}/>
                            </Grid>
                            <Grid sm={6} md={6} lg={6} xl={3} className="w-100 p-2">
                                <FormControl variant="outlined" className="w-100">
                                    <InputLabel htmlFor="filled-age-native-simple">تگ</InputLabel>
                                    <Select label="تگ"
                                            value={selectedTagId}
                                            onChange={e => {
                                                setSelectedTagId(e.target.value)
                                            }}>
                                        <option className="p-2" value={-1}>هیچکدام</option>
                                        {tagsList.map((item, index) => {
                                            return <option key={index} className="p-2"
                                                           value={item.id}>{item.name}</option>
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid sm={6} md={6} lg={6} xl={3} className='p-2 w-100'>
                                <RaikoCustomSelect
                                    items={[
                                        raikoCustomSelectItemGenerator(-1, "هیچکدام"),
                                        ...categoryInlineItems
                                    ]}
                                    labelText={"دسته بندی"}
                                    value={selectedCategoryId}
                                    setValue={setSelectedCategoryId}
                                />
                            </Grid>
                            <Grid sm={6} md={6} lg={6} xl={3} className='p-2 w-100'>
                                <label id='residenceStatus' className="toggle-switch-content">
                                    <span className="toggle-title">وضعیت</span>
                                    <label className="switch" htmlFor="MainCategory">
                                        <input
                                            type="checkbox"
                                            id="residenceStatus"
                                            checked={enabled}
                                            onChange={e => {
                                                setEnabled(e.target.checked)
                                            }}
                                        />
                                        <span className="toggle round"/>
                                    </label>

                                </label>
                            </Grid>
                            <Grid sm={12} md={12} lg={12} xl={12} className='p-2 w-100'>
                                <TextField
                                    className="w-100"
                                    label="توضیحات"
                                    multiline
                                    rows={6}
                                    variant="outlined"
                                    value={description}
                                    onChange={e => {
                                        setDescription(e.target.value)
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </section>
                <DialogActions>
                    <div className={css`display: flex;
                      padding: 1rem;
                      gap: 8px;`}>

                        <button className="btn-secondary" onClick={handleOpenDeleteDialog}>
                            حذف
                        </button>

                        <button className="btn-confirm" onClick={doChange}>
                            {selectedItemId >= 0 ? "بروزرسانی" : "افزودن"}
                        </button>

                    </div>
                </DialogActions>
            </Dialog>

            <Dialog onClose={handleCloseDeleteDialog} aria-labelledby="simple-dialog-title"
                    open={confirmDeleteDialogState}>
                <DialogTitle id="simple-dialog-title">حذف تراکنش</DialogTitle>
                <section className="d-flex flex-column justifyContentCenter alignItemsCenter p-3 h-100">
                    <span className={css`font-size: 16px;`}>آیا از حذف تراکنش اطمینان دارید؟!</span>
                    <span className={
                        css`font-size: 14px;
                          margin-top: 8px;
                          text-align: center;`}>با حذف تراکنش امکان بازیابی آن وجود نخواهد داشت!</span>
                    <div className={css`width: 100%;
                      display: flex;
                      flex-direction: row;
                      gap: 8px;
                      margin-top: 32px;
                    `}>
                        <button onClick={doDelete} className="btn-secondary flex-grow-1">حذف</button>
                        <button onClick={handleCloseDeleteDialog} className="btn-confirm  flex-grow-1">لغو</button>
                    </div>
                </section>
            </Dialog>

        </>

    )

};

export default AddNewTransaction